import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import {ThemeService} from '../../service/theme.service';


@Directive({
    selector: '[ph]'
})
export class PlaceholderDirective {

    private bundle: any;
    private placeholderKey: string;

    @Input() set ph(key: string) {
        this.placeholderKey = key;
        this.applyPh(this.placeholderKey);
    }

    public constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private themService: ThemeService
    ) {
        this.themService.getBundle()
            .subscribe(bundle => {
                this.bundle = bundle;
                this.applyPh(this.placeholderKey);
            });
    }

    private applyPh(key: string) {
        if (this.bundle && key) {
            const keyValue = this.themService.getValueOfTarget(this.bundle, key);
            if (keyValue) {
                this.renderer.setProperty(this.el.nativeElement, 'innerHTML', keyValue);
            }
        }
    }
}
